import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FileActions, FileActitonTypes } from './file.actions';
import { File } from '../../_models/file';
import { Workstep } from '../../_models/workstep';
import { OptiPiece } from '../../_models/opti_piece';

export interface State extends fromRoot.State {
	files: FileState;
}

export interface FileState {
  	currentFileId: bigint | null;
  	currentFile: File;
	fileList: File[];
	workstepsList: Workstep[];
	infoList: any;
	optiPieceList: any;
	pieceList: any;
	chargeOpti: OptiPiece[];
	lastExportedNameFile: any;

	filterFields: any;

	error: string;
}

const initialItem: File = {
	id: null,
	type_id: null,
	state: null,
	path: '',
  	name: '',
  	description: '',
  	date: null,
	active: false,
	order: null,
	code: null
};

const initialState: FileState = {
  	currentFileId: null,
  	currentFile: initialItem,
	fileList: [],
	workstepsList: [],
	infoList: [],
	optiPieceList: [],
	pieceList: {data: [], data_detail: []},
	chargeOpti: [],
	lastExportedNameFile: null,
	filterFields: [],
	error: ''
};

const getFileFeatureState = createFeatureSelector<FileState>('files');

export const getCurrentFileId = createSelector(
	getFileFeatureState,
	state => state.currentFileId
);

export const getCurrentFile = createSelector(
    getFileFeatureState,
    getCurrentFileId,
    (state, currentFileId) => {
        if (currentFileId == null) {
            return initialItem;
        } else {
            return currentFileId ? state.fileList.find(p => p.id === currentFileId) : null;
        }
    }
);

export const getInfoList = createSelector(
	getFileFeatureState,
	state => state.infoList
);

export const getFileList = createSelector(
	getFileFeatureState,
	state => state.fileList
);

export const getWorkstepsList = createSelector(
	getFileFeatureState,
	state => state.workstepsList
);

export const getOptiPieceList = createSelector(
	getFileFeatureState,
	state => state.optiPieceList
);

export const getPieceList = createSelector(
	getFileFeatureState,
	state => state.pieceList
);

export const getChargeOpti = createSelector(
	getFileFeatureState,
	state => state.chargeOpti
);

export const getLastExportedNameFile = createSelector(
	getFileFeatureState,
	state => state.lastExportedNameFile
);

export const getFilterFields = createSelector(
	getFileFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getFileFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: FileActions): FileState {

	// console.log('--> File Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action File type: ');
	// console.log(action.type);

	switch (action.type) {

		case FileActitonTypes.SetCurrentFile:

			console.log('--> Entrando en acción SetCurrentFile.');

			if (action.payload !== null) {

				return {
					...state,
					currentFileId: action.payload.id,
					currentFile: action.payload
				};
			} else {
				return {
					...state,
					currentFileId: null,
					currentFile: initialItem
				};
			}

		case FileActitonTypes.SetCurrentFileId:

			console.log('--> Entrando en acción SetCurrentFile.');

			return {
                ...state,
				currentFileId: action.payload
			};

		case FileActitonTypes.SetFilterFields:

			console.log('--> Entrando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

		case FileActitonTypes.ClearFile:

			console.log('--> Entrando en acción ClearFile.');

			return {
					...state,
					currentFileId: null
				};


		case FileActitonTypes.InicializeFile:

			console.log('--> Entrando en acción InicializeFile.');

			state = initialState;

			return state;
			
		case FileActitonTypes.SetExportedFileName:

			console.log('--> Entrando en acción SetExportedFileName.');

			if (action.payload !== null) {

				return {
					...state,
					lastExportedNameFile: action.payload
				};
			} else {
				return {
					...state,
					lastExportedNameFile: null
				};
			}


		case FileActitonTypes.LoadFilesSuccess:

			console.log('--> Entrando en acción LoadFilesSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					fileList: action.payload,
					error: ''
				};

		case FileActitonTypes.LoadFilesFail:

			console.log('--> Entrando en acción LoadFilesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					fileList: [],
					error: action.payload
				};

		case FileActitonTypes.UpdateFileSuccess:

			console.log('--> Entrando en acción UpdateFileSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxFileList = [];

			if (action.payload !== undefined) {
				console.log(' -> El proyecto a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxFileList = state.fileList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						fileList: auxFileList,
						currentFileId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La obra a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar la obra.'
				};
			}

		case FileActitonTypes.UpdateFileFail:

			console.log('--> Entrando en acción UpdateFileFail.');

			return {
					...state,
					error: action.payload
				};

		case FileActitonTypes.OptimizerFileSuccess:

			console.log('--> Entrando en acción OptimizerFileSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El archivo resultante es:');
				// console.log(action.payload);

				// Se asigna el código del archivo generado.
				// Viene en un campo llamado "turomas_JSON".
				state.currentFile.code = action.payload['turomas_JSON'];

				return {
						...state,
						currentFile: state.currentFile,
						error: ''
					};

			} else {
				console.log(' -> La archivo a optimizar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el archivo.'
				};
			}

		case FileActitonTypes.OptimizerFileFail:

			console.log('--> Entrando en acción OptimizerFileFail.');

			return {
					...state,
					error: action.payload
				};

		case FileActitonTypes.InfoFileListSuccess:

			console.log('--> Entrando en acción InfoFileListSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> Listado de archivos resultante es:');
				// console.log(action.payload);

				// Se asigna el código del archivo generado.
				// state.currentFile.code = action.payload;

				return {
						...state,
						// currentFile: state.currentFile,
						infoList: action.payload,
						error: ''
					};

			} else {
				console.log(' -> El listado de archivos a optimizar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el archivo.'
				};
			}

		case FileActitonTypes.InfoFileListFail:

			console.log('--> Entrando en acción InfoFileListFail.');

			return {
					...state,
					error: action.payload
				};


		case FileActitonTypes.CreateFileSuccess:

			console.log('--> Entrando en acción CreateFileSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentFiles = null;

			if (action.payload !== undefined) {
				console.log(' -> El archivo creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.fileList.push(action.payload);

					return {
						...state,
						fileList: state.fileList,
						currentFileId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El archivo a crear está vacío.');

				return {
					...state,
					currentFileId: null,
					error: 'No se ha podido crear el archivo.'
				};
			}

		case FileActitonTypes.CreateFileFail:

			console.log('--> Entrando en acción CreateFileFail.');

			return {
					...state,
					currentFileId: null,
					error: action.payload
				};

		case FileActitonTypes.DeleteFileSuccess:

			console.log('--> Entrando en acción DeleteFileSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentFiles = null;

			if (action.payload !== undefined) {
				console.log(' -> El archivo borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.fileList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de archivos:');
					console.log(filterList);

					return {
						...state,
						fileList: filterList,
						currentFileId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El archivo a borrar está vacío.');

				return {
					...state,
					currentFileId: null,
					error: 'No se ha podido borrar el archivo.'
				};
			}

		case FileActitonTypes.DeleteFileFail:

			console.log('--> Entrando en acción DeleteFileSuccess.');

			return {
					...state,
					currentFileId: null,
					error: action.payload
				};

		// ----------------
		// 		EMAILS
		// ----------------
		case FileActitonTypes.SendEmailSuccess:

			console.log('--> Entrando en acción SendEmailSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					error: ''
				};

		case FileActitonTypes.SendEmailFail:

			console.log('--> Entrando en acción SendEmailFail.');

			return {
					...state,
					error: action.payload
				};

		// ------------------------
		//     PASOS DE TRABAJO
		// ------------------------

		case FileActitonTypes.LoadWorkstepsSuccess:

			console.log('--> Entrando en acción LoadWorkstepsSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					workstepsList: action.payload,
					error: ''
				};

		case FileActitonTypes.LoadWorkstepsFail:

			console.log('--> Entrando en acción LoadWorkstepsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					fileList: [],
					error: action.payload
				};

		// ----------------
		//     IMPRIMIR
		// ----------------
		case FileActitonTypes.PrintFileSuccess:

			console.log('--> Entrando en acción PrintFileSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					error: ''
				};

		case FileActitonTypes.PrintFileFail:

			console.log('--> Entrando en acción PrintFileFail.');

			return {
					...state,
					error: action.payload
				};

		case FileActitonTypes.PrintSheetsSuccess:

			console.log('--> Entrando en acción PrintSheetsSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					error: ''
				};

		case FileActitonTypes.PrintSheetsFail:

			console.log('--> Entrando en acción PrintSheetsFail.');

			return {
					...state,
					error: action.payload
				};

		case FileActitonTypes.PrintEaselsSuccess:

			console.log('--> Entrando en acción PrintEaselsSuccess. => Payload = ');
			console.log(action.payload);
			
			let last_name_file = null;
			
			if (action.payload && action.payload.file_name) {
				last_name_file = action.payload.file_name;
				
			}

			return {
					...state,
					// lastExportedNameFile: last_name_file ? last_name_file : state.lastExportedNameFile,
					lastExportedNameFile: last_name_file,
					error: ''
				};

		case FileActitonTypes.PrintEaselsFail:

			console.log('--> Entrando en acción PrintEaselsFail.');

			return {
					...state,
					error: action.payload
				};

		// ----------------
		//     MAKE CSV
		// ----------------
		case FileActitonTypes.MakeCsvSuccess:

			console.log('--> Entrando en acción MakeCsvSuccess. => Payload = ');
			// console.log(action.payload);

			// Añadimos los datos del archivo al total de elementos de "files".
			state.fileList.push(action.payload);
			console.log(state.fileList);

			return {
					...state,
					fileList: state.fileList,
					error: ''
				};

		case FileActitonTypes.MakeCsvFail:

			console.log('--> Entrando en acción MakeCsvFail.');

			return {
					...state,
					fileList: [],
					error: action.payload
				};

		case FileActitonTypes.ResetFileList:

			console.log('--> Entrando en acción ResetFileList.');

			return {
					...state,
					fileList: []
				};

		// ----------------
		//     READ CSV
		// ----------------
		case FileActitonTypes.ReadCsvSuccess:

			console.log('--> Entrando en acción ReadCsvSuccess. => Payload = ');
			// console.log(action.payload);

			state.fileList.push(action.payload);

			return {
					...state,
					fileList: state.fileList,
					error: ''
				};

		case FileActitonTypes.ReadCsvFail:

			console.log('--> Entrando en acción ReadCsvFail.');

			return {
					...state,
					fileList: [],
					error: action.payload
				};

		// ----------------
		//     UPDATE CSV
		// ----------------
		case FileActitonTypes.UpdateFileCSVSuccess:

			console.log('--> Entrando en acción UpdateFileCSVSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El listado actual de CSVs después de cargar el archivo es:');
				// console.log(action.payload);

				return {
						...state,
						fileList: [], // Se vacía la lista CSVs.
						error: ''
					};

			} else {
				console.log(' -> El archivo a modificar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el archivo.'
				};
			}

		case FileActitonTypes.UpdateFileCSVFail:

			console.log('--> Entrando en acción UpdateFileCSVFail.');

			return {
					...state,
					error: action.payload
				};

		// ----------------------------------
		// 		PIEZAS OPTIMIZADAS
		// ----------------------------------

		case FileActitonTypes.LoadOptiPieceSuccess:

			console.log('--> Entrando en acción LoadOptiPieceSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					optiPieceList: action.payload,
					error: ''
				};

		case FileActitonTypes.LoadOptiPieceFail:

			console.log('--> Entrando en acción LoadOptiPieceFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					optiPieceList: [],
					error: action.payload
				};
				
		// ----------------------------------
		// 		PIEZAS FLOOR
		// ----------------------------------

		case FileActitonTypes.LoadPieceSuccess:

			console.log('--> Entrando en acción LoadPieceSuccess. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					pieceList: action.payload,
					error: ''
				};

		case FileActitonTypes.LoadPieceFail:

			console.log('--> Entrando en acción LoadPieceFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					pieceList: [],
					error: action.payload
				};

		default:
			return state;
	}
}
